import { ExternalLink } from '@ipfabric/ui-components/Link/Link';
import {
  type TableColumnFormatUrl,
  getValueFromKeyOfType,
} from '@ipfabric/utils';
import type { RenderedTableCell } from 'components/Table/cells/RenderedTableCell';
import {
  ARRAY_CELL_MAX_ITEMS,
  maybeWrapWithMore,
} from 'components/Table/cells/helpers/trimLargeArray';
import { array } from 'fp-ts';
import { pipe } from 'fp-ts/lib/function';
import { unsafeWrapWithReactKeyByIndex } from 'utils/react/unsafeWrapWithReactKeyByIndex';
import type { RenderCellContentArguments } from '../model/TableCellContentRenderFunction';

export const renderUrlCell = <TRow,>(
  format: TableColumnFormatUrl<TRow>,
  { row, severity }: RenderCellContentArguments<TRow>,
): RenderedTableCell => {
  const content = getValueFromKeyOfType(row, format.field);
  if (!content) {
    return {
      content: null,
    };
  }

  const renderLink = (value: string) => (
    <ExternalLink
      href={value}
      key={value}
      accent={severity === null ? 'positive' : 'contrast'}
    >
      {format.label ?? content}
    </ExternalLink>
  );

  return {
    content: Array.isArray(content)
      ? pipe(
          content,
          (a) => a.slice(0, ARRAY_CELL_MAX_ITEMS),
          array.map(renderLink),
          (a) => a.map(unsafeWrapWithReactKeyByIndex),
          (a) => a.join(', '),
          maybeWrapWithMore(content),
        )
      : renderLink(content),
  };
};
